<div class="agpr-themeEngagementAnalytics">
    <!-- Cards -->
    <div 
        class="agpr-themeEngagementAnalytics-row"
        [id]="id + '.engagement' + '.smallChart-top'"
    >
        <agpr-card-chart
            class="agpr-themeEngagementAnalytics-smallChart"
            [series]="[totalPostsSeries, previousPeriodTotalPostsSeries]"
            [color]="cardChartComponentHighlightColorEnum.volume"
            [bubbleTooltipMetric]="socialMetrics.VOLUME"
            [hidePrevious]="isArchiveSearch"
            headingLevel="4"
        >
        </agpr-card-chart>
        <agpr-card-chart
            class="agpr-themeEngagementAnalytics-smallChart"
            [series]="[totalEngagementsSeries, previousPeriodTotalEngagementsSeries]"
            [color]="cardChartComponentHighlightColorEnum.impressions"
            [bubbleTooltipMetric]="socialMetrics.ENGAGEMENTS"
            [hidePrevious]="isArchiveSearch"
            headingLevel="4"
        >
        </agpr-card-chart>
        <agpr-card-chart
            class="agpr-themeEngagementAnalytics-smallChart"
            [series]="[engagementsPerPostsSeries, previousPeriodEngagementsPerPostsSeries]"
            [color]="cardChartComponentHighlightColorEnum.engagements"
            [tooltip]="'Social.intelligence.themeAnalytics.engagement.engagementPerPostToolTip'"
            [bubbleTooltipMetric]="socialMetrics.ENGAGEMENTS_PER_POST"
            [hidePrevious]="isArchiveSearch"
            headingLevel="4"
        >
        </agpr-card-chart>
    </div>

    <!-- Engagements by Social Network Comparison -->
    <div
        class="agpr-themeEngagementAnalytics-chartContainer agpr-themeEngagementAnalytics-chartContainerPadding agpr-contextMenu-parent"
        #engagementsBySocialNetworkComparisonElement
        [id]="id + '.engagement' + '.engagementsBySocialNetworkComparisonChart'"
    >
        <div class="agpr-themeEngagementAnalytics-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="engagementsBySocialNetworkComparison_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart(
                    $event,
                    engagementsBySocialNetworkComparisonElement,
                    themeAnalyticsChartTypeEnum.ENGAGEMENT_BY_SOCIAL_MEDIA_COMPARISON
                )"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
        </div>
        <h4 class="agpr-themeEngagementAnalytics-complexChartContainerTitle">
            {{ 'Social.intelligence.themeAnalytics.engagement.engagementsBySocialNetworkComparison' | localize }}
        </h4>
        <div class="agpr-themeEngagementAnalytics-chartRow">
            <div
                class="agpr-themeEngagementAnalytics-chart"
            >
                <h5 class="agpr-themeEngagementAnalytics-chartTitle">{{ 'Social.intelligence.themeAnalytics.engagements' | localize }}</h5>
                <agpr-chart
                    [chart]="totalEngagementsChartModel"
                ></agpr-chart>
            </div>
            <div
                class="agpr-themeEngagementAnalytics-chart"
            >
                <h5 class="agpr-themeEngagementAnalytics-chartTitle">{{ 'Social.intelligence.themeAnalytics.engagementRate' | localize }}</h5>
                <agpr-chart
                    [chart]="engagementRateChartModel"
                ></agpr-chart>
            </div>
        </div>
    </div>

    <!-- Engagement Type by Social Network Comparison -->
    <div
        *ngIf="engagementTypeBySocialNetworkComparisonChartModel"
        class="agpr-themeEngagementAnalytics-chartContainer agpr-themeEngagementAnalytics-chartContainerPadding agpr-themeEngagementAnalytics-chartFixedHeight agpr-contextMenu-parent"
        #engagementTypeBySocialNetworkComparisonChartElement
        [id]="id + '.engagement' + '.engagementTypeBySocialNetworkComparisonChart'"
    >
        <div class="agpr-themeEngagementAnalytics-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="engagementTypeBySocialNetworkComparison_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart(
                    $event,
                    engagementTypeBySocialNetworkComparisonChartElement,
                    themeAnalyticsChartTypeEnum.ENGAGEMENT_TYPE_BY_SOCIAL_MEDIA_COMPARISON
                )"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
        </div>
        <h4 class="agpr-themeEngagementAnalytics-complexChartContainerTitleNoPadding">
            {{ 'Social.intelligence.themeAnalytics.engagement.engagementTypeBySocialNetworkComparison' | localize }}
        </h4>
        <agpr-chart-group
            [subChartsTotalWidthPercentage]="100"
            [charts]="engagementTypeBySocialNetworkComparisonChartModel"
            [id]="id + '.engagement' + '.engagementTypeBySocialNetworkComparison'"
        ></agpr-chart-group>
    </div>

    <div
        class="agpr-themeEngagementAnalytics-complexChartContainer agpr-contextMenu-parent"
        #engagementTypesChartElement
        [id]="id + '.engagement' + '.complexCharts'"
    >
        <div class="agpr-themeEngagementAnalytics-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="engagementTypes_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="supportedExportFormats"
                (exportMenuClicked)="exportChart(
                    $event,
                    engagementTypesChartElement,
                    themeAnalyticsChartTypeEnum.ENGAGEMENT_SUMMARY_PER_SOCIAL_MEDIA
                )"
                [social]="true"
                [contextMenu]="true"
            ></agpr-chart-export-menu>
        </div>
        <h4 class="agpr-themeEngagementAnalytics-complexChartContainerTitle">
            {{ 'Social.intelligence.themeAnalytics.engagement.summaryPerSocialNetwork' | localize }}
        </h4>
        <agpr-network-radio
            *ngIf="engagementTypesChart"
            id="themeEngagementAnalytics.socialNetworks"
            class="agpr-themeEngagementAnalytics-complexChartContainerNetworkSelector"
            [availableNetworks]="enabledNetworkTypes"
            (selectedNetwork)="setCurrentSocialType($event)"
            [showAllOption]="false"
            [showReddit]="false"
            [ariaLabel]="'Social.intelligence.themeAnalytics.engagement.socialNetworksLabel'"
        ></agpr-network-radio>

        <div class="agpr-themeEngagementAnalytics-complexChartContainerCharts">
            <div class="agpr-themeEngagementAnalytics-row">
                <!-- 3 card charts -->
                <agpr-card-chart
                    class="agpr-themeEngagementAnalytics-smallChart"
                    label="{{'Social.intelligence.themeAnalytics.engagement.' + currentSocialType +'.posts'}}"
                    [series]="[postsPerTypeSeries, previousPeriodPostsPerTypeSeries]"
                    [color]="cardChartComponentHighlightColorEnum.volume"
                    [bubbleTooltipMetric]="currentSocialType"
                    [hidePrevious]="isArchiveSearch"
                    headingLevel="5"
                >
                </agpr-card-chart>
                <agpr-card-chart
                    class="agpr-themeEngagementAnalytics-smallChart"
                    label="{{'Social.intelligence.themeAnalytics.engagement.' + currentSocialType +'.engagements'}}"
                    [series]="[engagementsPerTypeSeries, previousPeriodTotalEngagementsPerTypeSeries]"
                    [color]="cardChartComponentHighlightColorEnum.impressions"
                    [bubbleTooltipMetric]="socialMetrics.ENGAGEMENTS"
                    [hidePrevious]="isArchiveSearch"
                    headingLevel="5"
                >
                </agpr-card-chart>
                <agpr-card-chart
                    class="agpr-themeEngagementAnalytics-smallChart"
                    label="{{'Social.intelligence.themeAnalytics.engagement.' + currentSocialType +'.engagementRate'}}"
                    [series]="[engagementRatesPerTypeSeries, previousPeriodEngagementsRatesPerTypeSeries]"
                    [color]="cardChartComponentHighlightColorEnum.engagements"
                    [isPercentage]="true"
                    [bubbleTooltipMetric]="socialMetrics.ENGAGEMENT_RATE"
                    [hidePrevious]="isArchiveSearch"
                    headingLevel="5"
                >
                </agpr-card-chart>
            </div>

            <div class="agpr-themeEngagementAnalytics-chartSplitWidth">
                <!-- Engagement profile pie chart -->
                <div class="agpr-themeEngagementAnalytics-complexChartContainerLarge">
                    <agpr-chart *ngIf="engagementTypesChart" [chart]="engagementTypesChart"></agpr-chart>
                    <div #engagementProfileChartLegend class="agpr-themAnalyticsSummary-customLegendContainer"></div>
                </div>

                <!-- 4 card charts -->
                <div class="agpr-themeEngagementAnalytics-cardChartColumn">
                    <agpr-card-chart
                        [series]="[totalLikesSeries, previousPeriodTotalLikesSeries]"
                        [color]="cardChartComponentHighlightColorEnum.applause"
                        [layout]="cardChartComponentLayoutEnum.vertical"
                        label="{{'Social.intelligence.themeAnalytics.engagement.likes.' + currentSocialType}}"
                        [textAlignLeft]="true"
                        [bubbleTooltipMetric]="socialMetrics.LIKES"
                        [hidePrevious]="isArchiveSearch"
                        headingLevel="5"
                    >
                    </agpr-card-chart>

                    <agpr-card-chart
                        *ngIf="currentSocialType === allSocialTypes.twitter"
                        [series]="[totalQuotesSeries, previousPeriodTotalQuotesSeries]"
                        [color]="cardChartComponentHighlightColorEnum.conversation"
                        [layout]="cardChartComponentLayoutEnum.vertical"
                        [textAlignLeft]="true"
                        [bubbleTooltipMetric]="socialMetrics.QUOTES"
                        [hidePrevious]="isArchiveSearch"
                        headingLevel="5"
                    >
                    </agpr-card-chart>
                    <agpr-card-chart
                        [series]="[totalRepliesSeries, previousPeriodTotalRepliesSeries]"
                        [color]="cardChartComponentHighlightColorEnum.conversation"
                        [layout]="cardChartComponentLayoutEnum.vertical"
                        label="{{'Social.intelligence.themeAnalytics.engagement.replies.' + currentSocialType}}"
                        [textAlignLeft]="true"
                        [bubbleTooltipMetric]="this.currentSocialType === allSocialTypes.twitter ? socialMetrics.REPLIES : socialMetrics.COMMENTS"
                        [hidePrevious]="isArchiveSearch"
                        headingLevel="5"
                    >
                    </agpr-card-chart>
                    <agpr-card-chart
                        *ngIf="currentSocialType !== allSocialTypes.youtube && currentSocialType !== allSocialTypes.instagram"
                        [series]="[totalRetweetsSeries, previousPeriodTotalRetweetsSeries]"
                        [color]="cardChartComponentHighlightColorEnum.amplification"
                        [layout]="cardChartComponentLayoutEnum.vertical"
                        label="{{'Social.intelligence.themeAnalytics.engagement.retweets.' + currentSocialType}}"
                        [textAlignLeft]="true"
                        [bubbleTooltipMetric]="this.currentSocialType === allSocialTypes.twitter ? socialMetrics.RETWEETS : socialMetrics.SHARES"
                        [hidePrevious]="isArchiveSearch"
                        headingLevel="5"
                    >
                    </agpr-card-chart>
                    <agpr-card-chart
                        *ngIf="currentSocialType === allSocialTypes.youtube"
                        [series]="[totalViewsSeries, previousPeriodTotalViewsSeries]"
                        [color]="cardChartComponentHighlightColorEnum.amplification"
                        [layout]="cardChartComponentLayoutEnum.vertical"
                        label="{{'Social.intelligence.themeAnalytics.engagement.views'}}"
                        [textAlignLeft]="true"
                        [bubbleTooltipMetric]="socialMetrics.VIEWS"
                        [hidePrevious]="isArchiveSearch"
                        headingLevel="5"
                    >
                    </agpr-card-chart>
                </div>
            </div>
        </div>
    </div>

    <agpr-top-posts
        *ngIf="topPostsSeries"
        [id]="id + '.engagement' + '.topPosts'"
        [availableNetworkTypes]="enabledNetworkTypes"
        [series]="topPostsSeries"
        [excludedNetworkTypes]="[allSocialTypes.reddit]"
    ></agpr-top-posts>

    <agpr-top-terms
        [id]="id + '.engagement' + '.hashtagByEngagement'"
        [availableNetworkTypes]="enabledNetworkTypes"
        [hideWords]="true"
        [series]="topTermsSeries"
        [config]="topTermsConfig"
        [excludedNetworkTypes]="[allSocialTypes.reddit]"
    ></agpr-top-terms>
</div>
